import { ReactElement } from 'react';
import { MapCard } from '..';
import { MapDto } from '../../../models';
import { MapSearchResult, Project } from '../../../redux';
import { CardTemplateContainer } from '../../atoms';

export interface IMapCardContainerProps {
	maps: MapSearchResult[] | MapDto[];
	projectSelection?: Project[];
	columns: number;
	big?: boolean | undefined;
	className?: string;
	selectable?: boolean | undefined;
	onClick?: (map: MapSearchResult | MapDto) => void;
	onPreview?: (map: MapSearchResult | MapDto) => void;
}

export function MapCardContainer(props: IMapCardContainerProps): ReactElement {
	const {
		maps,
		projectSelection,
		columns,
		big,
		selectable,
		className,
		onClick,
		onPreview
	} = props;

	function handleClick(map: MapSearchResult | MapDto): void {
		if (onClick) {
			onClick(map);
		}
	}

	function equalsProject(
		mapId: string
	): (selectedProject: Project) => boolean {
		return (selectedProject: Project) => {
			const selectedIsProject: boolean = selectedProject.id !== undefined;

			return selectedIsProject
				? false
				: selectedProject.metaDataId === mapId;
		};
	}

	function mapIsSelected(mapId: string): boolean {
		return projectSelection
			? projectSelection.findIndex(equalsProject(mapId)) !== -1
			: false;
	}

	return (
		<CardTemplateContainer columns={columns} className={className}>
			{maps.map((map: MapSearchResult | MapDto, index: number) => (
				<MapCard
					onClick={handleClick}
					onPreview={onPreview}
					big={big}
					key={index}
					map={map}
					selectable={selectable}
					selected={mapIsSelected(map.id)}
				/>
			))}
		</CardTemplateContainer>
	);
}
